// PIXIアプリケーションの作成
const app = new PIXI.Application({
  width: window.innerWidth,
  height: window.innerHeight,
  transparent: true,
  antialias: true,
  resolution: window.devicePixelRatio || 1,
});

// bodyにアプリケーションを追加
const renderContent = document.querySelector('#background-balls');
renderContent.appendChild(app.view);

// 円をランダムに生成する関数
function createRandomCircle() {
  // ランダムな色を選択
  const colors = [0x009e95, 0x38b2f2, 0xffe907, 0xff004e];
  const randomColor = colors[Math.floor(Math.random() * colors.length)];

  // 円の直径をランダムに選択 (20px ～ maxCircleSize)
  const maxCircleSize = window.innerWidth <= 992 ? 15 : 50;
  const diameter = Math.floor(Math.random() * (maxCircleSize - 20 + 1)) + 20;

  // 新しい円のスプライトを作成
  const newCircle = new PIXI.Graphics();
  newCircle.beginFill(randomColor);
  newCircle.drawCircle(0, 0, diameter / 2);
  newCircle.endFill();

  // 新しい円の初期位置を画面の下部外に設定
  newCircle.x = Math.random() * window.innerWidth;
  newCircle.y = window.innerHeight + diameter / 2;

  // 新しい円の動きとサイズ変化を設定
  const speed = Math.random() * 2 + 0.5; // 上昇スピードをランダムに設定
  const sizeChangeSpeed = Math.random() * 0.1 + 0.01; // サイズ変化の速さをランダムに設定
  const sizeChangeRange = Math.random() * 100 + 50; // サイズ変化の範囲をランダムに設定
  const swayAmount = (Math.random() - 0.5) * 1.5; // 左右に均等に揺れる振れ幅をランダムに設定
  const initialAngle = (Math.random() - 0.5) * 20; // 初期の角度をランダムに設定

  app.ticker.add(() => {
    // 左右に均等に揺れる動きを加える
    newCircle.x += Math.sin((newCircle.y + initialAngle) / 1000) * swayAmount;

    // 新しい円の上昇
    newCircle.y -= speed;

    // 一定の間隔で新しい円のサイズを変化
    const newDiameter =
      diameter +
      Math.sin((newCircle.y + initialAngle) / sizeChangeRange) *
        sizeChangeSpeed;
    newCircle.clear();
    newCircle.beginFill(randomColor);
    newCircle.drawCircle(0, 0, newDiameter / 2);
    newCircle.endFill();

    if (
      newCircle.y + newDiameter / 2 < 0 ||
      newCircle.x + newDiameter / 2 < 0 ||
      newCircle.x - newDiameter / 2 > window.innerWidth
    ) {
      // 画面上部や画面外に超えたら新しい円を再配置
      newCircle.x = Math.random() * window.innerWidth;
      newCircle.y = window.innerHeight + newDiameter / 2;
    }
  });

  // ステージに新しい円を追加
  app.stage.addChild(newCircle);
}

// 円を無限に生成
const maxCircles = window.innerWidth <= 992 ? 5 : 7; // 最大円の数を設定
let circleCounter = 0;
const circleInterval = setInterval(() => {
  createRandomCircle();
  circleCounter++;
  if (circleCounter >= maxCircles) {
    clearInterval(circleInterval);
  }
}, 500);

// リサイズ時の処理
window.addEventListener('resize', () => {
  app.renderer.resize(window.innerWidth, window.innerHeight);
});

// アプリケーションを実行
app.start();
